export const marketingTier = {
  Ndata: ['Unknown', 'Tier 1', 'Tier 2', 'Tier 3'],
};
